<div  [ngClass]="context == 'client_view' ? 'main-content-clientView' : 'main-content background'">
  <div class="first-row">
    <div class="container-header">
        <span class="style-title2 clickable" (click)="toPreviousPath()" *ngIf="context !== 'client_view'">{{previousRouterName}}</span>
        <span class="material-icons style-icon-title" nz-icon nzType="right" nzTheme="outline" *ngIf="context !== 'client_view'"></span>
        <span class="back-button" *ngIf="context === 'client_view'" (click)="returnToList()">
            <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
        </span>
        <span class="style-title">Câmeras {{groupName}}</span>
    </div>
  
    <div class="group_data">
        <span class="camera_data">Câmeras: {{ totalAmountGroup }}</span>
        <span>Detecções: {{ totalAmountAnalytic }}</span>
        <span>Clientes: {{ groupData ? groupData[0].clients_info_group.length : 0}}</span>
        <span>Convidados: {{ groupData ? groupData[0].associateds_info_group.length : 0}}</span>
    </div>
  </div>

  <div class="filter">
    <div class="search-input">
      <input type="text" placeholder="Pesquisar"
      [formControl]="searchInputControl" (keyup)="requestSearch()">
      <i nz-icon nzType="search" nzTheme="outline" class="clickable" (click)="requestSearch()"></i>
    </div>
    <div class="selector-container">
        <app-filter [list]="sortOptions"
        [selected]="1"
        [type]="'simple'"
        (filterStatusChange)="changeSort($event)"></app-filter>
    </div>
  </div>

  <div *ngIf="hasCameras">
    <nz-table #camTable class="table style-table antd-table" [nzData]="cameras" [hidden]="loading"
    [nzFrontPagination]="'false'" showTitle="false" 
    [nzPaginationPosition]="'both'"
    [nzSize]="'small'"
    [nzTotal]="totalAmountGroup"
    [(nzPageSize)]="camLimit"
    [(nzPageIndex)]="pageIndex"
    (nzPageIndexChange)="onPageIndexChange()"
    [nzTableLayout]="'auto'">
      <thead>
        <tr>
          <th class="table-thumb">Câmera</th>
          <th class="table-name">Nome</th>
          <th class="table-client">Cliente</th>
          <th class="table-plan">Plano</th>
          <th class="table-detec">Detecções</th>
          <th class="table-detec"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let camera of camTable.data; let index = index">
          <!-- Câmera -->
          <td [class.deleting]="camera.deleted" [class.offline]="!camera.active">
            <div class="style-thumbnail clickable">
              <img class="image-img" [src]="camera.cache_thumb | async | safeHtml" (error)="brokenImageHandler($event)">
              <div *ngIf="camera.active" class="image-overlay" (click)="viewLiveCamera(camera)">
                <img src="/assets/img/fullscreen-hover.svg">
              </div>
            </div>
          </td>
          <!-- Nome -->
          <td [nzBreakWord]="true">{{camera.alias}}
            <p class="id-cam">
              #{{camera.id}}
            </p>
          </td>
          <!-- Cliente -->
          <td>{{returnClientName(camera.id_user)}}</td>
          <!-- Plano -->
          <td [hidden]="!camera.active">
            <span class="plan-title" *ngIf="!loading">Câmera {{returnPlanFromId(camera.id_plan).resolution.alias}}</span>
            <span class="plan-days" *ngIf="!loading">{{processPlural(returnPlanFromId(camera.id_plan).days_storage, 'dia')}}</span>
          </td>
          <!-- Detecções -->
          <td [hidden]="!camera.active">
            <div *ngIf="camera.integrated_camera" class="integrated">Analítico<br>integrado</div>
            <div *ngIf="!camera.integrated_camera" class="analytics-container">
              <div class="analiticos-container center-item">
                <span class="cursor_choice">{{camera.analytics}}</span>
                <div class="button-container">
                  <button [disabled]="!camera.active" (click)="goToAnalyticsPage(camera)" mat-raised-button
                    class="btn btn-sm btn-just-icon style-icon-add button_add_analytics"
                    [class.disabled_cam]="camera.analytic_status && camera.analytic_status == 'disabled'">
                    <!-- loading -->
                    <span *ngIf="camera.is_processing_analytic"
                          nz-icon nzType="loading" nzTheme="outline"
                          class="icon-table">
                    </span>

                    <!-- exclamação quando disabled -->
                    <span *ngIf="!camera.is_processing_analytic && camera.analytic_status==='disabled'"
                          nz-icon nzType="exclamation" nzTheme="outline"
                          nz-tooltip
                          nzTooltipTitle="Detecções desativadas por excesso de alertas, edite o(s) analítico(s) para voltar a receber alertas"
                          nzTooltipOverlayClassName="camera-actived-date"
                          class="icon-table">
                    </span>

                    <!-- “+” nos demais casos -->
                    <span *ngIf="!camera.is_processing_analytic && camera.analytic_status!=='disabled'"
                          nz-icon nzType="plus" nzTheme="outline"
                          class="icon-table">
                    </span>
                  </button>
                  <img class="test" *ngIf="camera.is_testing_analytics" src="../../../assets/img/Icons/testanalytic.svg" alt="">
                </div>
              </div>
             
            </div>
          </td>
          <!-- Câmera bloqueada -->
          <td [colSpan]="(camera.active) ? '0' : '5'" class="lt-md:hidden xs:block" [hidden]="camera.active">
            <div class="card-bloqueado" *ngIf="!camera.active">
              <div class="deleting-label" *ngIf="camera.deleted">
                <i class="camera-spinner" nz-icon nzType="loading" nzTheme="outline"></i>
                <span class="text-deleting">Câmera sendo apagada </span>
              </div>
              <p class="card-title" *ngIf="!camera.deleted" style="text-align: center;">Câmera bloqueada</p>
              <p class="card-text" *ngIf="!camera.deleted" style="text-align: center;">Entre em contato com seu
                fornecedor para reativar a sua câmera</p>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>  
  </div>
    
  <app-feedback [noFound]="true" imageUrl="nofound.png" [transparent]="true" *ngIf="!loading && !hasCameras"></app-feedback>
  
    <div *ngIf="loading" class="loading_container">
      <span nz-icon class="center" nzType="loading" nzTheme="outline" style="font-size: 40px"></span>
    </div>
</div>

<app-analytics-controller (loadingCameraList)="loadingEvent($event)" (exitModal)="dispatchGroupData()"></app-analytics-controller>
<app-modal></app-modal>
